// export const games = {
//     "yx": "Trò chơi",
//     "yxms": "Trong trò chơi được mã hóa, tất cả các quyết định quyết định kết quả của cuộc thi được tạo ra trước bằng hình thức băm, và kết quả của trò chơi sẽ không bị thay đổi bởi ý chí của bất kỳ ai, đảm bảo sự công bằng tuyệt đối!",
//     "mnsm": "Mô phỏng Trò chơi",
//     "ljqw": "Chơi Ngay",
//     loading: 'Đang tải, vui lòng đợi'
// }
export const games = {
    yx: 'trò chơi',
    yxms: 'Tất cả kết quả quyết định của trò chơi được mã hóa được tạo dưới dạng băm trước khi tham gia, không thể thay đổi bởi ý chí của bất kỳ ai, đảm bảo công bằng và minh bạch tuyệt đối!',
    mnsm: 'chơi thử mô phỏng',
    ljqw: 'chơi ngay',
    loading: 'đang tải, vui lòng chờ',
    dyh: 'Hợp đồng quyền chọn đa dạng cho bạn lựa chọn, lợi nhuận gấp 100 lần, lợi tức đầu tư ngắn hạn siêu cao',
    qyhy:'hợp đồng quyền chọn',
    kd:'Mở một đơn đặt hàng',
    qsyhys:'hợp đồng',
    qt:'Đầu Tư Thú Vị',
    ljjy: "Giao dịch ngay",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/vi.js